import React from "react";

import ProcessInfo from "./ProcessInfo";

import findNode from "../../util/findNode";
import fieldTypeAsString from "../../util/fieldTypeAsString";
import { Node, Group } from "../../types";

import "../../styles/Processes.css";

type Props = {
  nodes: Node[];
  type: Group;
};

/**
 * Used to generate a set of tables describing ether all the workflows or
 * datasets in a Hailer workspace decided with the prop `type`.
 *
 * @author Juhana Kuparinen <juhana.kuparinen@kvanttori.fi>
 */

const Tables = ({ nodes, type }: Props) => {
  const nodesByType = nodes.filter(node => node.group === type);

  // Filtering out nodes of the given type
  const docs = nodesByType.map((node, index) => {
    // Fields
    const fields = node.fields?.map(field => {

      let options = '';

      if(!field.data || !field.id) {
        console.warn("Found corrupted field!", field);
        return(null);
      }
        options = field.data
          .map(data => findNode(nodes, data))
          .filter(option => option)
          .join(", ");

      return (
        <tr key={field.id}>
          <td>{field.name}</td>
          <td>
            {fieldTypeAsString(field.type)}
            {field.functionEnabled ? (
              <div className="be_function-icon">ƒ</div>
            ) : null}
          </td>
          <td>{field.description || "-"}</td>
          <td>{field.placeholder || "-"}</td>
          <td>{field.defaultValue || "-"}</td>
          <td>{field.required ? "Yes" : "No"}</td>
          <td>
            {field.type === "activitylink"
              ? "Linked To: " + options
              : options || "-"}
          </td>
          <td>{field.id}</td>
        </tr>
      );
    });

    let phases: (JSX.Element | null)[] = [];
    if (node.phases){
      phases = node.phases?.map(phase => {

      if(!phase.id) {
        console.warn("Found corrupted phase!", phase);
        return null;
      }

      return (
        <tr key={phase.id}>
          <td>{phase.name}</td>
          {type === "dataset" ? null : (
            <td>
              {phase.linkedTo?.length
                ? phase.linkedTo
                    ?.map(id => {
                      const foundPhase = node.phases?.find(
                        phase => phase.id === id
                      );
                      return foundPhase?.name || "undefined";
                    })
                    .join(", ")
                : "-"}
            </td>
          )}
          <td>{phase.id}</td>
        </tr>
      );
    });}

    // Done
    return (
      <ProcessInfo
        key={`comp-${node.id}-${index}`}
        node={node}
        fields={fields}
        phases={phases}
        index={index}
        type={type}
      />
    );
  });

  return (
    <div id={`be_${type}`} className="be_Tables">
      <h1>{type === "workflow" ? "Workflows" : "Datasets"}</h1>
      <hr />
      {docs}
    </div>
  );
};

export default Tables;
